module.exports = __webpack_public_path__ + "img/20200507151144TIM截图20200507150730.77ab9708.png";